// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3QXjw","content":"styles_content__2oBez","selectAll":"styles_selectAll__1fKQz"};